/**
 * Shared Ozonetel + Cube wrap-up list.
 * Seed a hardcoded list immediately — JSON import shape and S3 from stage.moneytor.in can both come back empty.
 * Cube's own iframe WRAP dropdown is campaign-configured and is not this list.
 */
import referenceDispositionList from './dialersDispositionList.json';

export const DIALERS_DISPOSITION_LIST_S3_URL =
  'https://moneytor-uploads.s3.ap-south-1.amazonaws.com/developer/portfolio-zestmoneyJSONData/dialersDispositionList.json';

const HARDCODED_LIST: string[] = [
  'Account closed',
  'Auto Dispose',
  'Call back',
  'Call drop',
  'CashBack Offer',
  'CD',
  'Client cancellation',
  'Customer deliberately misleading',
  'Customer disputed default amount',
  'Customer disputed last EMI of payment',
  'Customer Expired',
  'Customer indicated amount to be paid',
  'Customer indicated possibility of pay back',
  'DND',
  'Escalation',
  'Foreclosure Offer',
  'Future prospects',
  'Inbound',
  'Language barrier',
  'Leave Message',
  'LS',
  'Need FollowUp',
  'NOC Request',
  'No contact details',
  'Not interested',
  'Not Reachable',
  'NRTP',
  'Paid',
  'Partial Paid',
  'Profile Update',
  'PTP',
  'Ringing No Response',
  'Settlement Offer',
  'Special',
  'Switch off',
  'Waiver Request',
  'WN',
  'Awaiting credit report',
  'Budgeting done',
  'Care introduction',
  'Enrolled client',
  'New client',
  'Payment reminder',
  'Program explained',
  'Current',
  'Debt amount not qualified',
  'Need loan',
  'No Outstandings',
  'Not looking for settlement',
  'Not answering',
  'Number not in service',
];

function normalizeDispositionList(raw: unknown): string[] {
  let value: unknown = raw;
  for (let i = 0; i < 4; i++) {
    if (Array.isArray(value)) {
      return value.map((item) => String(item ?? '').trim()).filter(Boolean);
    }
    if (value && typeof value === 'object' && 'default' in (value as object)) {
      value = (value as { default: unknown }).default;
      continue;
    }
    break;
  }
  return [];
}

const FALLBACK_LIST = (() => {
  const fromJson = normalizeDispositionList(referenceDispositionList);
  return fromJson.length ? fromJson : HARDCODED_LIST.slice();
})();

let activeList: string[] = FALLBACK_LIST.slice();
let initPromise: Promise<void> | null = null;

export function getDialersDispositionList(): readonly string[] {
  if (activeList.length) {
    return activeList;
  }
  if (FALLBACK_LIST.length) {
    return FALLBACK_LIST;
  }
  return HARDCODED_LIST;
}

export function ensureDialersDispositionListReady(): Promise<void> {
  return initDialersDispositionList();
}

export function initDialersDispositionList(): Promise<void> {
  if (initPromise) {
    return initPromise;
  }
  const fetchS3 = fetch(DIALERS_DISPOSITION_LIST_S3_URL)
    .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
    .then((raw) => {
      const next = normalizeDispositionList(raw);
      if (next.length) {
        activeList = next;
      }
    });
  const timeout = new Promise<void>((_resolve, reject) => {
    setTimeout(() => reject(new Error('timeout')), 4000);
  });
  initPromise = Promise.race([fetchS3, timeout]).catch(() => {
    if (!activeList.length) {
      activeList = FALLBACK_LIST.slice();
    }
  });
  return initPromise;
}

void initDialersDispositionList();
